"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RememberedAccountsLayout = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = _interopRequireWildcard(require("./styles.css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const RememberedAccountsLayout = _ref => {
  let {
    title,
    content,
    controls
  } = _ref;
  const deviceType = (0, _uiKit.useDeviceType)();
  return /*#__PURE__*/React.createElement("div", {
    className: styles['container']
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['title'], styles[`title--${deviceType}`])
  }, title), /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['content'], styles[`content--${deviceType}`])
  }, content, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['controls'], styles[`controls--${deviceType}`])
  }, controls)));
};
exports.RememberedAccountsLayout = RememberedAccountsLayout;